import { Facebook, Linkedin, X, MessageCircle } from "lucide-react";
import { SocialButton } from "./social/SocialButton";
import { socialConfig } from "./social/socialConfig";
import { SocialShareHeader } from "./social/SocialShareHeader";

export const SocialShare = () => {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://onarrivebientot.nlocale.fr")}&quote=${encodeURIComponent(socialConfig.facebook.text)}`;
  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent("https://onarrivebientot.nlocale.fr")}&summary=${encodeURIComponent(socialConfig.linkedin.text)}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialConfig.twitter.text)}`;
  const whatsappShareUrl = `https://wa.me/?text=${encodeURIComponent(socialConfig.whatsapp.text)}`;

  return (
    <div className="bg-primary/5 rounded-lg p-6 shadow-sm">
      <SocialShareHeader />
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <SocialButton
          href={facebookShareUrl}
          icon={Facebook}
          label="Facebook"
          tooltip={socialConfig.facebook.tooltip}
          className={socialConfig.facebook.className}
        />
        <SocialButton
          href={linkedinShareUrl}
          icon={Linkedin}
          label="LinkedIn"
          tooltip={socialConfig.linkedin.tooltip}
          className={socialConfig.linkedin.className}
        />
        <SocialButton
          href={twitterShareUrl}
          icon={X}
          label="X"
          tooltip={socialConfig.twitter.tooltip}
          className={socialConfig.twitter.className}
        />
        <SocialButton
          href={whatsappShareUrl}
          icon={MessageCircle}
          label="WhatsApp"
          tooltip={socialConfig.whatsapp.tooltip}
          className={socialConfig.whatsapp.className}
        />
      </div>
    </div>
  );
};